import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginApi } from "../../Api/api";
import { logoutUser } from "../../slices/userSlice";

const Auth = ({ children }) => {
  const { user } = useSelector((state) => state?.userSlice);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCheckSubscription = async () => {
    try {
      const response = await loginApi(user?.msisdn);
    } catch (error) {
      if (error?.response?.status == 403) {
        dispatch(logoutUser());
        navigate("/");
      }
      if (error?.response?.data?.error?.status == 0) {
        dispatch(logoutUser());
        navigate("/");
      }
      if (error?.response?.data?.error?.status == 1) {
        dispatch(logoutUser());
        navigate("/");
      }
    }
  }

  useEffect(() => {
    if (!user) {
      navigate("/");
    } else {
      handleCheckSubscription();
    }
  }, []);

  return <>{children}</>;
};

export default Auth;
